import { BranchCode, GetRgiRiskResponse, GetUnemploymentRiskResponse, GetUpiRiskResponse } from "api/risk"
import { CenteredDashboardContent } from "features/dashboard/DashboardContent"
import { BranchStepConfigFactory, createStepConfig } from "features/subscription-process/navigation/Steps/createStepConfig"
import { StepPageWrapper } from "features/subscription-process/navigation/Steps/StepPageWrapper"
import { useStepNavigation } from "features/subscription-process/navigation/Steps/useStepNavigation"
import { FC, useMemo } from "react"
import { useRiskData } from "../contexts/selectors/selectors"
import { MriStepIdentifier, RGIStepIdentifier, UnemploymentStepIdentifier, UPIStepIdentifier } from "../types/enums"
import { MRI_ROUTES } from "../utils/mriRoutes"
import { PersonDetails } from "./components/PersonDetails"

const BRANCH_STEP_CONFIG: Partial<Record<BranchCode, BranchStepConfigFactory>> = {
  [BranchCode.UPI]: createStepConfig({
    next: {
      identifier: UPIStepIdentifier.RealEstateRegistration,
      route: "/simulation/inscription/cbno/biens",
      label: "Aller au tarificateur",
    },
  }),
  [BranchCode.RGI]: createStepConfig({
    next: {
      identifier: RGIStepIdentifier.RealEstateRegistration,
      route: "/simulation/inscription/gli/biens",
    },
  }),
  [BranchCode.Unemployment]: createStepConfig({
    next: {
      identifier: UnemploymentStepIdentifier.Profiling,
      route: "/simulation/profilage/chomage",
    },
  }),
  [BranchCode.Mri]: createStepConfig({
    next: {
      identifier: MriStepIdentifier.CopropertyRegistration,
      route: MRI_ROUTES.copropertyRegistration,
    },
  }),
}

const ActorRegistrationSummary: FC = () => {
  // fetchSubscriptionProcess is called by SubscriptionProcessWrapper - no need to call it here
  const riskData = useRiskData() as GetUnemploymentRiskResponse | GetUpiRiskResponse | GetRgiRiskResponse | null
  const person = useMemo(() => riskData?.person, [riskData])
  const { stepConfig, goToNext, goToPrevious } = useStepNavigation(BRANCH_STEP_CONFIG)

  if (!person) {
    return null
  }

  return (
    <CenteredDashboardContent>
      <StepPageWrapper
        stepConfig={stepConfig}
        onNext={goToNext}
        onPrevious={goToPrevious}
        withoutPadding
      >
        <PersonDetails person={person} />
      </StepPageWrapper>
    </CenteredDashboardContent>
  )
}

export default ActorRegistrationSummary
